<template>
  <div class="cart-page">
    <cartContent></cartContent>
    <courseWishlist  v-if="$store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length>0"></courseWishlist>
    <trendingCourses  v-if="showTrendingCard && $store.getters.getCartData.items !== undefined && $store.getters.getCartData.items !== null && $store.getters.getCartData.items.length == 0 && $store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length==0"></trendingCourses>
    <libraryCards  v-if="showTrendingCard && showLibraryCard && $store.getters.getCartData.items !== undefined && $store.getters.getCartData.items !== null && $store.getters.getCartData.items.length == 0 && $store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length==0"></libraryCards>
    <newVideoCards  v-if="showLibraryCard && showLibraryCard && showNewVideoCard && $store.getters.getCartData.items !== undefined && $store.getters.getCartData.items !== null && $store.getters.getCartData.items.length == 0 && $store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length==0"></newVideoCards>
    <infinite-loading v-if ="($store.getters.getCartData.items !== undefined && $store.getters.getCartData.items !== null && $store.getters.getCartData.items.length == 0) && ($store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length==0)" @infinite="infiniteHandler" spinner="waveDots" ref="infiniteLoader">
        <span slot ='no-results'></span>
        <span slot ='no-more'></span>
    </infinite-loading>
</div>
</template>

<script>
import footerArea from '../common/footerArea.vue'
import {INSTANCE_NAME} from '@/components/common/constants.js'
import InfiniteLoading from 'vue-infinite-loading'
import { EventBus } from '@/main.js'
import cartContent from './cartContent.vue'
import courseWishlist from '@/components/wishList/courseWishList'
import courseCards from '../home/courseCards'
import libraryCards from '@/components/home/libraryCards'
import newVideoCards from '@/components/home/newVideoCards'
import trendingCourses from '@/components/home/trendingCourses'
export default {
  name: 'cart',
  components: {
    InfiniteLoading,
    footerArea,
    cartContent,
    courseCards,
    courseWishlist,
    libraryCards,
    newVideoCards,
    trendingCourses
  },
  data () {
    return {
      showTrendingCard: false,
      showLibraryCard: false,
      showNewVideoCard: false,
      globalState: ''
    }
  },
  created () {
    if (INSTANCE_NAME === 'MAHADEMY') {
      this.$router.push('/home')
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted () {
    EventBus.$emit('showNav', false)
  },
  methods: {
    // infiniteHandler - starts lazy loading
    infiniteHandler ($state) {
      this.globalState = $state
      setTimeout(() => {
        this.showTrendingCard = true
        // this.showLibraryCard = true
        $state.loaded()
      }, 2000)
    },
    handleScroll () {
      if (this.showTrendingCard && !this.showLibraryCard) {
        setTimeout(() => {
          this.showLibraryCard = true
          if (this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            this.globalState.complete()
          }
        }, 2000)
      } else if (this.showTrendingCard && this.showLibraryCard) {
        setTimeout(() => {
          this.showNewVideoCard = true
          if (this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            this.globalState.complete()
          }
        }, 2000)
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';

.cart-page{
.tags-nav{
    padding:20px 0 10px 0;
    @mixin tags-css($color, $colorText) {
        margin-right:5px;
        display: inline-block;
        margin-bottom:10px;
        cursor: pointer;
        color: $colorText;
        border-radius: 2px;
        padding: 4px 15px;
        background-color: $color;
        font-weight:600; 
        .tag-css-text{
            padding-right:5px;
        }
        .tag-css-x{
            border-radius: 2px;
            font-weight: 200;
            padding:4px 10px;
            background-color: darken($color, 9%);
            &:hover{
                background-color: darken($color, 15%);    
            }
        }
    }
    .tags-back{@include tags-css(transparent, #333); span{padding-left:5px;  text-transform: capitalize;} &:hover{color:#000;}}
    .tag-css-select-category{ @include tags-css(#26b9e3, #fff);}
    .tag-css-unselect-category { @include tags-css(#e3e3e3,#333);  &:hover{ @include tags-css(#26b9e3, #fff);} }
    .tag-css-select-topic { @include tags-css(#3E62BE, #fff); }
    .tag-css-unselect-topic { @include tags-css(#e3e3e3,#333);  &:hover{ @include tags-css(#3E62BE, #fff);} }
}
}
</style>




// WEBPACK FOOTER //
// src/components/cart/cart.vue?b26383f8